module.exports = function getResource(label, vars = []) {
    let resources = {
        beautyMatchesPopupText: 'Une correspondance beauté est une personne qui possède les mêmes traits beauté que vous. Pour profiter pleinement de cette fonctionnalité, assurez-vous d’ajouter tous vos traits beauté dans votre',
        beautyMatchesPopupLink: 'Profil de la collectivité',
        beautyMatchesPopupClose: 'Compris.'
    };
    return resources[label];
};
